export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "close-sidebar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fermer le panneau"])},
        "logo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logo Vote pour ça"])}
      },
      "en": {
        "close-sidebar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Close sidebar"])},
        "logo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vote pour ça logo"])}
      }
    }
  })
}
